import React from "react";
import Auth from "../../containers/Auth/Auth";
import IndexPage from "../../containers/IndexPage/IndexPage";
import ContactPage from "../../containers/ContactPage/ContactPage";
import Profile from "../../containers/Profile/Profile";
import WrapperRouter from "../Wrapper/WrapperRouter";
import * as routerTypes from "./routerTypes";
import { routerLinks } from "./routerLinks";
import PersonAddPage from "../../containers/Person/PersonAddPage";
import PersonListPage from "../../containers/Person/PersonListPage";
import CarContractAddPage from "../../containers/CarContract/CarContractAddPage";
import ChequeAddPage from "../../containers/Cheque/ChequeAddpage";
import ChequeListPage from "../../containers/Cheque/ChequeListPage";
import CarContractListPage from "../../containers/CarContract/CarContractListPage";
import CarContractEditPage from "../../containers/CarContract/CarContractEditPage";
import ChequeContractAddPage from "../../containers/ChequeContract/ChequeContractAddPage";
import ChequeContractListPage from "../../containers/ChequeContract/ChequeContractListPage";
import ChequeEditpage from "../../containers/Cheque/ChequeEditpage";
import PersonEditPage from "../../containers/Person/PersonEditPage";
import ChequeContractEditPage from "../../containers/ChequeContract/ChequeContractEditPage";
import ChequeListUserPage from "../../containers/Cheque/ChequeListUserPage";
import ChequeContractListUserPage from "../../containers/ChequeContract/ChequeContractListUserPage";
import CarContractListUserPage from "../../containers/CarContract/CarContractListUserPage";
import ChequeListHistoryPage from "../../containers/Cheque/ChequeListHistoryPage";
import ChequeListCarContractPage from "../../containers/Cheque/ChequeListCarContractPage";
import PersonAdminAddPage from "../../containers/Person/PersonAdminAddPage";
import SettingListPage from "../../containers/Setting/SettingListPage";
import SettingEditPage from "../../containers/Setting/SettingEditPage";
import PersonAdminListPage from "../../containers/Person/PersonAdminListPage";
import PersonAdminEditPage from "../../containers/Person/PersonAdminEditPage";
import Logout from "../../containers/Logout";
import DebitCreditEditPage from "../../containers/DebitCredit/DebitCreditEditPage";
import DebitCreditAddPage from "../../containers/DebitCredit/DebitCreditAddPage";
import DebitCreditListPage from "../../containers/DebitCredit/DebitCreditListPage";
import DebitCreditListUserPage from "../../containers/DebitCredit/DebitCreditListUserPage";
import BankAccountAddPage from "../../containers/BankAccount/BankAccountAddPage";
import BankAccountEditPage from "../../containers/BankAccount/BankAccountEditPage";
import BankAccountListPage from "../../containers/BankAccount/BankAccountListPage";
import BankAccountListUserPage from "../../containers/BankAccount/BankAccountListUserPage";
import LegalEntityAddPage from "../../containers/LegalEntity/LegalEntityAddPage";
import LegalEntityListPage from "../../containers/LegalEntity/LegalEntityListPage";
import LegalEntityEditPage from "../../containers/LegalEntity/LegalEntityEditPage";
import LegalEntityListUserPage from "../../containers/LegalEntity/LegalEntityListUserPage";
// import Amir from "../../components/Test";

export const RouteAll = [
  // {
  //   name: "111",
  //   key: "xxx",
  //   path: "/test",
  //   exact: false,
  //   isAuthenticated: false,
  //   isUsedHeader: false,
  //   isUsedFooter: false,
  //   classMainDiv: null,
  //   render: () => (
  //     <WrapperRouter keyName={"xxx"}>
  //       <Amir />
  //     </WrapperRouter>
  //   ),
  // },
  {
    name: "login",
    key: routerTypes.LOGIN,
    path: routerLinks(routerTypes.LOGIN),
    exact: false,
    isAuthenticated: false,
    isUsedHeader: false,
    isUsedFooter: false,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.LOGIN}>
        <Auth selectTab={"login"} />
      </WrapperRouter>
    ),
  },
  {
    name: "ForgetPassword",
    key: routerTypes.FORGETPASSWORD,
    path: routerLinks(routerTypes.FORGETPASSWORD),
    exact: false,
    isAuthenticated: false,
    isUsedHeader: false,
    isUsedFooter: false,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.FORGETPASSWORD}>
        <Auth selectTab={"ForgetPassword"} />
      </WrapperRouter>
    ),
  },
  {
    name: "logout",
    key: routerTypes.LOGOUT,
    path: routerLinks(routerTypes.LOGOUT),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: false,
    isUsedFooter: false,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.LOGOUT}>
        <Logout />
      </WrapperRouter>
    ),
  },

  {
    name: "register_confirm",
    key: routerTypes.REGISTERCONFIRM,
    path: routerLinks(routerTypes.REGISTERCONFIRM),
    exact: false,
    isAuthenticated: false,
    isUsedHeader: false,
    isUsedFooter: false,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.REGISTERCONFIRM}>
        <Auth selectTab={"register_confirm"} />
      </WrapperRouter>
    ),
  },
  {
    name: "register",
    key: routerTypes.REGISTER,
    path: routerLinks(routerTypes.REGISTER),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: false,
    isUsedFooter: false,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.REGISTER}>
        <Auth selectTab={"register"} />
      </WrapperRouter>
    ),
  },
  {
    name: "Contact",
    key: routerTypes.CONTACT,
    path: routerLinks(routerTypes.CONTACT),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: "container-fluid",
    render: () => (
      <WrapperRouter keyName={routerTypes.CONTACT}>
        <ContactPage />
      </WrapperRouter>
    ),
  },
  {
    name: "person add",
    key: routerTypes.PERSON_ADD,
    path: routerLinks(routerTypes.PERSON_ADD),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.PERSON_ADD}>
        <PersonAddPage />
      </WrapperRouter>
    ),
  },
  {
    name: "person add admin",
    key: routerTypes.PERSON_ADD_ADMIN,
    path: routerLinks(routerTypes.PERSON_ADD_ADMIN),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.PERSON_ADD_ADMIN}>
        <PersonAdminAddPage />
      </WrapperRouter>
    ),
  },

  {
    name: "person edit",
    key: routerTypes.PERSON_EDIT,
    path: routerLinks(routerTypes.PERSON_EDIT),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.PERSON_EDIT}>
        <PersonEditPage />
      </WrapperRouter>
    ),
  },
  {
    name: "person edit admin",
    key: routerTypes.PERSON_EDIT_ADMIN,
    path: routerLinks(routerTypes.PERSON_EDIT_ADMIN),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.PERSON_EDIT_ADMIN}>
        <PersonAdminEditPage />
      </WrapperRouter>
    ),
  },

  {
    name: "person list",
    key: routerTypes.PERSON_LIST,
    path: routerLinks(routerTypes.PERSON_LIST),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.PERSON_LIST}>
        <PersonListPage />
      </WrapperRouter>
    ),
  },
  {
    name: "person list admin",
    key: routerTypes.PERSON_LIST_ADMIN,
    path: routerLinks(routerTypes.PERSON_LIST_ADMIN),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.PERSON_LIST_ADMIN}>
        <PersonAdminListPage />
      </WrapperRouter>
    ),
  },
  {
    name: "car contract add",
    key: routerTypes.CAR_CONTRACT_ADD,
    path: routerLinks(routerTypes.CAR_CONTRACT_ADD),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CAR_CONTRACT_ADD}>
        <CarContractAddPage />
      </WrapperRouter>
    ),
  },
  {
    name: "car contract list",
    key: routerTypes.CAR_CONTRACT_LIST,
    path: routerLinks(routerTypes.CAR_CONTRACT_LIST),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CAR_CONTRACT_LIST}>
        <CarContractListPage />
      </WrapperRouter>
    ),
  },
  {
    name: "car contract list user",
    key: routerTypes.CAR_CONTRACT_LIST_USER,
    path: routerLinks(routerTypes.CAR_CONTRACT_LIST_USER),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CAR_CONTRACT_LIST_USER}>
        <CarContractListUserPage />
      </WrapperRouter>
    ),
  },
  {
    name: "cheque contract add",
    key: routerTypes.CHEQUE_CONTRACT_ADD,
    path: routerLinks(routerTypes.CHEQUE_CONTRACT_ADD),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CHEQUE_CONTRACT_ADD}>
        <ChequeContractAddPage />
      </WrapperRouter>
    ),
  },
  {
    name: "cheque contract edit",
    key: routerTypes.CHEQUE_CONTRACT_EDIT,
    path: routerLinks(routerTypes.CHEQUE_CONTRACT_EDIT),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CHEQUE_CONTRACT_EDIT}>
        <ChequeContractEditPage />
      </WrapperRouter>
    ),
  },
  {
    name: "cheque contract list",
    key: routerTypes.CHEQUE_CONTRACT_LIST,
    path: routerLinks(routerTypes.CHEQUE_CONTRACT_LIST),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CHEQUE_CONTRACT_LIST}>
        <ChequeContractListPage />
      </WrapperRouter>
    ),
  },
  {
    name: "cheque contract list user",
    key: routerTypes.CHEQUE_CONTRACT_LIST_USER,
    path: routerLinks(routerTypes.CHEQUE_CONTRACT_LIST_USER),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CHEQUE_CONTRACT_LIST_USER}>
        <ChequeContractListUserPage />
      </WrapperRouter>
    ),
  },
  {
    name: "car contract edit",
    key: routerTypes.CAR_CONTRACT_EDIT,
    path: routerLinks(routerTypes.CAR_CONTRACT_EDIT),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CAR_CONTRACT_EDIT}>
        <CarContractEditPage />
      </WrapperRouter>
    ),
  },

  {
    name: "cheque add",
    key: routerTypes.CHEQUE_ADD,
    path: routerLinks(routerTypes.CHEQUE_ADD),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CHEQUE_ADD}>
        <ChequeAddPage />
      </WrapperRouter>
    ),
  },

  {
    name: "cheque list",
    key: routerTypes.CHEQUE_LIST,
    path: routerLinks(routerTypes.CHEQUE_LIST),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CHEQUE_LIST}>
        <ChequeListPage />
      </WrapperRouter>
    ),
  },
  {
    name: "cheque list history",
    key: routerTypes.CHEQUE_LIST_HISTORY,
    path: routerLinks(routerTypes.CHEQUE_LIST_HISTORY),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CHEQUE_LIST_HISTORY}>
        <ChequeListHistoryPage />
      </WrapperRouter>
    ),
  },
  {
    name: "cheque list car contract",
    key: routerTypes.CHEQUE_LIST_CAR_CONTRACT,
    path: routerLinks(routerTypes.CHEQUE_LIST_CAR_CONTRACT),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CHEQUE_LIST_CAR_CONTRACT}>
        <ChequeListCarContractPage />
      </WrapperRouter>
    ),
  },
  {
    name: "cheque list user",
    key: routerTypes.CHEQUE_LIST_USER,
    path: routerLinks(routerTypes.CHEQUE_LIST_USER),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CHEQUE_LIST_USER}>
        <ChequeListUserPage />
      </WrapperRouter>
    ),
  },
  {
    name: "cheque list",
    key: routerTypes.CHEQUE_EDIT,
    path: routerLinks(routerTypes.CHEQUE_EDIT),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.CHEQUE_EDIT}>
        <ChequeEditpage />
      </WrapperRouter>
    ),
  },

  {
    name: "debit credit edit",
    key: routerTypes.DEBIT_CREDIT_EDIT,
    path: routerLinks(routerTypes.DEBIT_CREDIT_EDIT),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.DEBIT_CREDIT_EDIT}>
        <DebitCreditEditPage />
      </WrapperRouter>
    ),
  },
  {
    name: "debit credit add",
    key: routerTypes.DEBIT_CREDIT_ADD,
    path: routerLinks(routerTypes.DEBIT_CREDIT_ADD),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.DEBIT_CREDIT_ADD}>
        <DebitCreditAddPage />
      </WrapperRouter>
    ),
  },
  {
    name: "debit credit list",
    key: routerTypes.DEBIT_CREDIT_LIST,
    path: routerLinks(routerTypes.DEBIT_CREDIT_LIST),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.DEBIT_CREDIT_LIST}>
        <DebitCreditListPage />
      </WrapperRouter>
    ),
  },
  {
    name: "debit credit list user",
    key: routerTypes.DEBIT_CREDIT_LIST_USER,
    path: routerLinks(routerTypes.DEBIT_CREDIT_LIST_USER),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.DEBIT_CREDIT_LIST_USER}>
        <DebitCreditListUserPage />
      </WrapperRouter>
    ),
  },

  {
    name: "bank account edit",
    key: routerTypes.BANK_ACCOUNT_EDIT,
    path: routerLinks(routerTypes.BANK_ACCOUNT_EDIT),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.BANK_ACCOUNT_EDIT}>
        <BankAccountEditPage />
      </WrapperRouter>
    ),
  },
  {
    name: "bank account add",
    key: routerTypes.BANK_ACCOUNT_ADD,
    path: routerLinks(routerTypes.BANK_ACCOUNT_ADD),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.BANK_ACCOUNT_ADD}>
        <BankAccountAddPage />
      </WrapperRouter>
    ),
  },
  {
    name: "bank account list",
    key: routerTypes.BANK_ACCOUNT_LIST,
    path: routerLinks(routerTypes.BANK_ACCOUNT_LIST),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.BANK_ACCOUNT_LIST}>
        <BankAccountListPage />
      </WrapperRouter>
    ),
  },
  {
    name: "bank account list user",
    key: routerTypes.BANK_ACCOUNT_LIST_USER,
    path: routerLinks(routerTypes.BANK_ACCOUNT_LIST_USER),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.BANK_ACCOUNT_LIST_USER}>
        <BankAccountListUserPage />
      </WrapperRouter>
    ),
  },

  {
    name: "legal entity edit",
    key: routerTypes.LEGAL_ENTITY_EDIT,
    path: routerLinks(routerTypes.LEGAL_ENTITY_EDIT),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.LEGAL_ENTITY_EDIT}>
        <LegalEntityEditPage />
      </WrapperRouter>
    ),
  },
  {
    name: "legal entity add",
    key: routerTypes.LEGAL_ENTITY_ADD,
    path: routerLinks(routerTypes.LEGAL_ENTITY_ADD),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.LEGAL_ENTITY_ADD}>
        <LegalEntityAddPage />
      </WrapperRouter>
    ),
  },
  {
    name: "legal entity list",
    key: routerTypes.LEGAL_ENTITY_LIST,
    path: routerLinks(routerTypes.LEGAL_ENTITY_LIST),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.LEGAL_ENTITY_LIST}>
        <LegalEntityListPage />
      </WrapperRouter>
    ),
  },
  {
    name: "legal entity list user",
    key: routerTypes.LEGAL_ENTITY_LIST_USER,
    path: routerLinks(routerTypes.LEGAL_ENTITY_LIST_USER),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.LEGAL_ENTITY_LIST_USER}>
        <LegalEntityListUserPage />
      </WrapperRouter>
    ),
  },

  {
    name: "setting list",
    key: routerTypes.SETTING_LIST,
    path: routerLinks(routerTypes.SETTING_LIST),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.SETTING_LIST}>
        <SettingListPage />
      </WrapperRouter>
    ),
  },
  {
    name: "setting edit",
    key: routerTypes.SETTING_EDIT,
    path: routerLinks(routerTypes.SETTING_EDIT),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.SETTING_EDIT}>
        <SettingEditPage />
      </WrapperRouter>
    ),
  },
  {
    name: "Profile",
    key: routerTypes.PROFILE,
    path: routerLinks(routerTypes.PROFILE),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: null,
    render: () => (
      <WrapperRouter keyName={routerTypes.PROFILE}>
        <Profile />
      </WrapperRouter>
    ),
  },
  {
    name: "Home",
    key: routerTypes.HOME,
    path: routerLinks(routerTypes.HOME),
    exact: true,
    isAuthenticated: false,
    isUsedHeader: true,
    isUsedFooter: true,
    classMainDiv: "container-fluid",
    render: () => (
      <WrapperRouter keyName={routerTypes.HOME}>
        <IndexPage />
      </WrapperRouter>
    ),
  },
];

export const getRouterWithPath = (key) => {
  let routeselect = RouteAll.find((data) => {
    if (data.key === key) {
      return data;
    }
  });

  if (!routeselect) {
    routeselect = RouteAll.find((data) => {
      if (data.key == routerTypes.HOME) {
        return data;
      }
    });
  }

  return routeselect;
};
